import {BaseApi} from './base-api';
import Vue from 'vue';

export class MiscAccountApi extends BaseApi {
    static apiUri = 'misc-accounts';

    /** @return {Promise<EntityHttpResponse<PageResponse<MiscAccountDto>>>} */
    static getAllMiscAccounts () {
        return Vue.http.get(this.apiUri)
    }

    /**
     * @return {Promise<EntityHttpResponse<MiscAccountDto>>}
     * @param {Number} id
     * */
    static getMiscAccount (id) {
        return Vue.http.get(this.apiUri + '/' + id)
    }

    /**
     * @return {Promise<EntityHttpResponse<MiscAccountDto>>}
     * @param {MiscAccountCreateRequest} miscAccountCreateRequest
     * */
    static createMiscAccount (miscAccountCreateRequest) {
        return Vue.http.post(this.apiUri, miscAccountCreateRequest)
    }

    /**
     * @return {Promise<EntityHttpResponse<MiscAccountDto>>}
     * @param {Number} miscAccountId
     * @param {MiscAccountUpdateRequest} miscAccountUpdateRequest
     * */
    static updateMiscAccount (miscAccountId, miscAccountUpdateRequest) {
        return Vue.http.patch(this.apiUri + '/' + miscAccountId, miscAccountUpdateRequest)
    }

    /**
     * @return {Promise<EntityHttpResponse<void>>}
     * @param {Number} id
     * */
    static deleteMiscAccount (id) {
        return Vue.http.delete(this.apiUri + '/' + id)
    }
}
